import { setAssetMissingQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';

export default async function setAssetMissing(
apiClient,
{ assetId })
{
  const requestParams = {
    mutation: setAssetMissingQuery,
    variables: { assetId },
    context: {
      module: 'upload'
    }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.setAssetMissing || error) {return null;}

  return data.setAssetMissing;
}